"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
exports.Currency = [
    { CountryAndCurrency: "American Dollar", Code: "USD", Symbol: "$" },
    { CountryAndCurrency: "British Pound", Code: "GBP", Symbol: "£" },
    { CountryAndCurrency: "Canadian Dollar", Code: "CAD", Symbol: "$" },
    { CountryAndCurrency: "Euro", Code: "EUR", Symbol: "€" },
    { CountryAndCurrency: "Japanese Yen", Code: "JPY", Symbol: "¥" },
    { CountryAndCurrency: "Swiss Franc", Code: "CHF", Symbol: "CHF" },
    { CountryAndCurrency: "Australian Dollar", Code: "AUD", Symbol: "$" },
    { CountryAndCurrency: "Albanian Lek", Code: "ALL", Symbol: "Lek" },
    { CountryAndCurrency: "Algerian Dinar", Code: "DZD", Symbol: "دج" },
    { CountryAndCurrency: "Angolan Kwanza", Code: "AOA", Symbol: "Kz" },
    { CountryAndCurrency: "Afghan Afghani", Code: "AFN", Symbol: "؋" },
    { CountryAndCurrency: "Argentina Peso", Code: "ARS", Symbol: "$" },
    { CountryAndCurrency: "Armenian Dram", Code: "AMD", Symbol: "֏" },
    { CountryAndCurrency: "Aruba Guilder", Code: "AWG", Symbol: "ƒ" },
    { CountryAndCurrency: "Australia Dollar", Code: "AUD", Symbol: "$" },
    { CountryAndCurrency: "Azerbaijan Manat", Code: "AZN", Symbol: "₼" },
    { CountryAndCurrency: "Bahamas Dollar", Code: "BSD", Symbol: "$" },
    { CountryAndCurrency: "Bahraini Dinar", Code: "BHD", Symbol: ".د.ب" },
    { CountryAndCurrency: "Bangladesh Taka", Code: "BDT", Symbol: "৳" },
    { CountryAndCurrency: "Barbados Dollar", Code: "BBD", Symbol: "$" },
    { CountryAndCurrency: "Belarus Ruble", Code: "BYN", Symbol: "Br" },
    { CountryAndCurrency: "Belize Dollar", Code: "BZD", Symbol: "BZ$" },
    { CountryAndCurrency: "Bermuda Dollar", Code: "BMD", Symbol: "$" },
    { CountryAndCurrency: "Bhutan Ngultrum", Code: "BTN", Symbol: "Nu" },
    { CountryAndCurrency: "Bolivia Bolíviano", Code: "BOB", Symbol: "$b" },
    { CountryAndCurrency: "Bosnia and Herzegovina Mark", Code: "BAM", Symbol: "KM" },
    { CountryAndCurrency: "Botswana Pula", Code: "BWP", Symbol: "P" },
    { CountryAndCurrency: "Brazil Real", Code: "BRL", Symbol: "R$" },
    { CountryAndCurrency: "Brunei Darussalam Dollar", Code: "BND", Symbol: "$" },
    { CountryAndCurrency: "Bulgaria Lev", Code: "BGN", Symbol: "лв" },
    { CountryAndCurrency: "Cabo Verde Escudo", Code: "CVE", Symbol: "$" },
    { CountryAndCurrency: "Cambodia Riel", Code: "KHR", Symbol: "៛" },
    { CountryAndCurrency: "Canada Dollar", Code: "CAD", Symbol: "$" },
    { CountryAndCurrency: "Cayman Islands Dollar", Code: "KYD", Symbol: "$" },
    { CountryAndCurrency: "Chile Peso", Code: "CLP", Symbol: "$" },
    { CountryAndCurrency: "China Yuan Renminbi", Code: "CNY", Symbol: "¥" },
    { CountryAndCurrency: "Colombia Peso", Code: "COP", Symbol: "$" },
    { CountryAndCurrency: "Comorian Franc", Code: "KMF", Symbol: "CF" },
    { CountryAndCurrency: "Congolese Franc", Code: "CDF", Symbol: "FC" },
    { CountryAndCurrency: "Costa Rica Colon", Code: "CRC", Symbol: "₡" },
    { CountryAndCurrency: "Croatia Kuna", Code: "HRK", Symbol: "kn" },
    { CountryAndCurrency: "Cuba Peso", Code: "CUP", Symbol: "₱" },
    { CountryAndCurrency: "Czech Republic Koruna", Code: "CZK", Symbol: "Kč" },
    { CountryAndCurrency: "Denmark Krone", Code: "DKK", Symbol: "kr" },
    { CountryAndCurrency: "Dijibouti Franc", Code: "DJF", Symbol: "Fdj" },
    { CountryAndCurrency: "Dominican Republic Peso", Code: "DOP", Symbol: "RD$" },
    { CountryAndCurrency: "East Caribbean Dollar", Code: "XCD", Symbol: "$" },
    { CountryAndCurrency: "Egypt Pound", Code: "EGP", Symbol: "£" },
    { CountryAndCurrency: "El Salvador Colon", Code: "SVC", Symbol: "$" },
    { CountryAndCurrency: "Eritrea Nakfa", Code: "ERN", Symbol: "ናቕፋ" },
    { CountryAndCurrency: "Euro Member Countries", Code: "EUR", Symbol: "€" },
    { CountryAndCurrency: "Eswatini Lilangeni", Code: "SZL", Symbol: "L" },
    { CountryAndCurrency: "Ethiopian Birr", Code: "ETB", Symbol: "ብር" },
    { CountryAndCurrency: "Falkland Islands Pound", Code: "FKP", Symbol: "£" },
    { CountryAndCurrency: "Fiji Dollar", Code: "FJD", Symbol: "$" },
    { CountryAndCurrency: "Gabian Dalasi", Code: "GMD", Symbol: "D" },
    { CountryAndCurrency: "Georgia Lari", Code: "GEL", Symbol: "ლ" },
    { CountryAndCurrency: "Ghana Cedi", Code: "GHS", Symbol: "¢" },
    { CountryAndCurrency: "Gibraltar Pound", Code: "GIP", Symbol: "£" },
    { CountryAndCurrency: "Guatemala Quetzal", Code: "GTQ", Symbol: "Q" },
    { CountryAndCurrency: "Guernsey Pound", Code: "GGP", Symbol: "£" },
    { CountryAndCurrency: "Guinean Franc", Code: "GNF", Symbol: "GFR" },
    { CountryAndCurrency: "Guyana Dollar", Code: "GYD", Symbol: "$" },
    { CountryAndCurrency: "Haitian Gourde", Code: "HTG", Symbol: "G" },
    { CountryAndCurrency: "Honduras Lempira", Code: "HNL", Symbol: "L" },
    { CountryAndCurrency: "Hong Kong Dollar", Code: "HKD", Symbol: "$" },
    { CountryAndCurrency: "Hungary Forint", Code: "HUF", Symbol: "Ft" },
    { CountryAndCurrency: "Iceland Krona", Code: "ISK", Symbol: "kr" },
    { CountryAndCurrency: "India Rupee", Code: "INR", Symbol: "₹" },
    { CountryAndCurrency: "Indonesia Rupiah", Code: "IDR", Symbol: "Rp" },
    { CountryAndCurrency: "Iran Rial", Code: "IRR", Symbol: "﷼" },
    { CountryAndCurrency: "Iraqi Dinar", Code: "IQD", Symbol: "ع.د" },
    { CountryAndCurrency: "Isle of Man Pound", Code: "IMP", Symbol: "£" },
    { CountryAndCurrency: "Israel Shekel", Code: "ILS", Symbol: "₪" },
    { CountryAndCurrency: "Jamaica Dollar", Code: "JMD", Symbol: "J$" },
    { CountryAndCurrency: "Japan Yen", Code: "JPY", Symbol: "¥" },
    { CountryAndCurrency: "Jersey Pound", Code: "JEP", Symbol: "£" },
    { CountryAndCurrency: "Jordian Dinar", Code: "JOD", Symbol: "د.ا" },
    { CountryAndCurrency: "Kazakhstan Tenge", Code: "KZT", Symbol: "лв" },
    { CountryAndCurrency: "Kenyan Shiling", Code: "KES", Symbol: "/=" },
    { CountryAndCurrency: "Korea (North) Won", Code: "KPW", Symbol: "₩" },
    { CountryAndCurrency: "Kuwaiti Dinar", Code: "KWD", Symbol: "د.ك" },
    { CountryAndCurrency: "Kyrgyzstan Som", Code: "KGS", Symbol: "лв" },
    { CountryAndCurrency: "Laos Kip", Code: "LAK", Symbol: "₭" },
    { CountryAndCurrency: "Lebanon Pound", Code: "LBP", Symbol: "£" },
    { CountryAndCurrency: "Lesotho Loti", Code: "LSL", Symbol: "L" },
    { CountryAndCurrency: "Liberia Dollar", Code: "LRD", Symbol: "$" },
    { CountryAndCurrency: "Libyan Dinar", Code: "LYD", Symbol: "ل.د" },
    { CountryAndCurrency: "Macau Pataca", Code: "MOP", Symbol: "MOP$" },
    { CountryAndCurrency: "Macedonia Denar", Code: "MKD", Symbol: "ден" },
    { CountryAndCurrency: "Malagasy Ariary", Code: "MGA", Symbol: "Ar" },
    { CountryAndCurrency: "Malaysia Ringgit", Code: "MYR", Symbol: "RM" },
    { CountryAndCurrency: "Malawi Kwacha", Code: "MWK", Symbol: "MK" },
    { CountryAndCurrency: "Maldives Rufiyaa", Code: "MVR", Symbol: ".ރ" },
    { CountryAndCurrency: "Mauritania Ouguiya", Code: "MRU", Symbol: "UM" },
    { CountryAndCurrency: "Mauritius Rupee", Code: "MUR", Symbol: "₨" },
    { CountryAndCurrency: "Mexico Peso", Code: "MXN", Symbol: "$" },
    { CountryAndCurrency: "Moldovan Leu", Code: "MDL", Symbol: "L" },
    { CountryAndCurrency: "Mongolia Tughrik", Code: "MNT", Symbol: "₮" },
    { CountryAndCurrency: "Moroccan Dirham", Code: "MAD", Symbol: "د.إ" },
    { CountryAndCurrency: "Mozambique Metical", Code: "MZN", Symbol: "MT" },
    { CountryAndCurrency: "Myanmar Kyat", Code: "MMK", Symbol: "K" },
    { CountryAndCurrency: "Namibia Dollar", Code: "NAD", Symbol: "$" },
    { CountryAndCurrency: "Nepal Rupee", Code: "NPR", Symbol: "₨" },
    { CountryAndCurrency: "Netherlands Antilles Guilder", Code: "ANG", Symbol: "ƒ" },
    { CountryAndCurrency: "New Zealand Dollar", Code: "NZD", Symbol: "$" },
    { CountryAndCurrency: "Nicaragua Cordoba", Code: "NIO", Symbol: "C$" },
    { CountryAndCurrency: "Nigeria Naira", Code: "NGN", Symbol: "₦" },
    { CountryAndCurrency: "Norway Krone", Code: "NOK", Symbol: "kr" },
    { CountryAndCurrency: "Oman Rial", Code: "OMR", Symbol: "﷼" },
    { CountryAndCurrency: "Pakistan Rupee", Code: "PKR", Symbol: "₨" },
    { CountryAndCurrency: "Panama Balboa", Code: "PAB", Symbol: "฿" },
    { CountryAndCurrency: "Papua New Guinea Kina", Code: "PGK", Symbol: "K" },
    { CountryAndCurrency: "Paraguay Guarani", Code: "PYG", Symbol: "Gs" },
    { CountryAndCurrency: "Peru Sol", Code: "PEN", Symbol: "S/." },
    { CountryAndCurrency: "Philippines Peso", Code: "PHP", Symbol: "₱" },
    { CountryAndCurrency: "Poland Zloty", Code: "PLN", Symbol: "zł" },
    { CountryAndCurrency: "Qatar Riyal", Code: "QAR", Symbol: "﷼" },
    { CountryAndCurrency: "Romania Leu", Code: "RON", Symbol: "lei" },
    { CountryAndCurrency: "Russia Ruble", Code: "RUB", Symbol: "₽" },
    { CountryAndCurrency: "Rwanda Franc", Code: "RWF", Symbol: "R₣" },
    { CountryAndCurrency: "Saint Helena Pound", Code: "SHP", Symbol: "£" },
    { CountryAndCurrency: "Samoa Tala", Code: "WST", Symbol: "WS$" },
    { CountryAndCurrency: "Sao Tome and Principe Dobra", Code: "STN", Symbol: "Db" },
    { CountryAndCurrency: "Saudi Arabia Riyal", Code: "SAR", Symbol: "﷼" },
    { CountryAndCurrency: "Serbia Dinar", Code: "RSD", Symbol: "Дин." },
    { CountryAndCurrency: "Seychelles Rupee", Code: "SCR", Symbol: "₨" },
    { CountryAndCurrency: "Sierra Leone Leone", Code: "SLL", Symbol: "Le" },
    { CountryAndCurrency: "Singapore Dollar", Code: "SGD", Symbol: "$" },
    { CountryAndCurrency: "Solomon Islands Dollar", Code: "SBD", Symbol: "$" },
    { CountryAndCurrency: "Somalia Shilling", Code: "SOS", Symbol: "S" },
    { CountryAndCurrency: "South Africa Rand", Code: "ZAR", Symbol: "R" },
    { CountryAndCurrency: "South Korean Won", Code: "KRW", Symbol: "₩" },
    { CountryAndCurrency: "South Sudanese Pound", Code: "SSP", Symbol: "£" },
    { CountryAndCurrency: "Sri Lanka Rupee", Code: "LKR", Symbol: "₨" },
    { CountryAndCurrency: "Sudanese Pound", Code: "SDG", Symbol: "ج.س." },
    { CountryAndCurrency: "Sweden Krona", Code: "SEK", Symbol: "kr" },
    { CountryAndCurrency: "Switzerland Franc", Code: "CHF", Symbol: "CHF" },
    { CountryAndCurrency: "Suriname Dollar", Code: "SRD", Symbol: "$" },
    { CountryAndCurrency: "Syria Pound", Code: "SYP", Symbol: "£" },
    { CountryAndCurrency: "Taiwan New Dollar", Code: "TWD", Symbol: "NT$" },
    { CountryAndCurrency: "Tajikistan Somoni", Code: "TJS", Symbol: "SM" },
    { CountryAndCurrency: "Tanzanian Shilling", Code: "TZS", Symbol: "TSh" },
    { CountryAndCurrency: "Thailand Baht", Code: "THB", Symbol: "฿" },
    { CountryAndCurrency: "Trinidad and Tobago Dollar", Code: "TTD", Symbol: "TT$" },
    { CountryAndCurrency: "Tonga Pa'anga", Code: "TOP", Symbol: "T$" },
    { CountryAndCurrency: "Tunisian Dinar", Code: "TND", Symbol: "د.ت" },
    { CountryAndCurrency: "Turkmenistan New Manat", Code: "TMT", Symbol: "T" },
    { CountryAndCurrency: "Turkey Lira", Code: "TRY", Symbol: "₺" },
    { CountryAndCurrency: "Tuvalu Dollar", Code: "TVD", Symbol: "$" },
    { CountryAndCurrency: "Ukraine Hryvnia", Code: "UAH", Symbol: "₴" },
    { CountryAndCurrency: "UAE-Dirham", Code: "AED", Symbol: "د.إ" },
    { CountryAndCurrency: "Uganda Shilling", Code: "UGX", Symbol: "USh" },
    { CountryAndCurrency: "United Kingdom Pound", Code: "GBP", Symbol: "£" },
    { CountryAndCurrency: "United States Dollar", Code: "USD", Symbol: "$" },
    { CountryAndCurrency: "Uruguay Peso", Code: "UYU", Symbol: "$U" },
    { CountryAndCurrency: "Uzbekistan Som", Code: "UZS", Symbol: "лв" },
    { CountryAndCurrency: "Vanuatu Vatu", Code: "VUV", Symbol: "VT" },
    { CountryAndCurrency: "Venezuela Bolívar", Code: "VEF", Symbol: "Bs" },
    { CountryAndCurrency: "Vietnam Dong", Code: "VND", Symbol: "₫" },
    { CountryAndCurrency: "Yemen Rial", Code: "YER", Symbol: "﷼" },
    { CountryAndCurrency: "Zambian Kwacha", Code: "ZMW", Symbol: "ZK" },
    { CountryAndCurrency: "Zimbabwe Dollar", Code: "ZWD", Symbol: "Z$" }
];
exports.default = exports.Currency;
//# sourceMappingURL=Currency.js.map
